import { t } from "../../../../../utils/i18n";
import React from "react";
import { Transaction } from "../Types";

interface Props {
  transactions: Transaction[];
  cardType: string;
}

const Body: React.FC<Props> = ({ transactions, cardType }) => {
  return (
    <tbody>
      {transactions.map((transaction, i) => (
        <tr key={i}>
          <td>{transaction.executed_at}</td>
          <td>{transaction.trn_ref_number}</td>
          <td>{transaction.description}</td>
          {cardType !== "virtual" && (
            <td>{transaction.cr_amount ? transaction.cr_amount : "-"}</td>
          )}
          <td>{transaction.dr_amount ? transaction.dr_amount : "-"}</td>
          {cardType !== "virtual" && <td>{transaction.end_bal}</td>}
          {cardType === "virtual" && <td>{transaction.status}</td>}
          {cardType === "virtual" && <td>{transaction.declined_reason}</td>}
        </tr>
      ))}
      {transactions.length === 0 && (
        <tr>
          <td colSpan={8} className="text-center">
            {t("cards.activities.empty")}
          </td>
        </tr>
      )}
    </tbody>
  );
};

export default Body;
